<template>
  <v-container>
    <Nav />
    <h1>Groups</h1>
    <v-table density="compact">
      <thead>
        <tr>
          <th>Id</th>
          <th>Name</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, idx) in groups"
          :key="idx"
        >
          <td>{{ item.id }}</td>
          <td>{{ item.name }}</td>
        </tr>
      </tbody>
    </v-table>
  </v-container>
</template>
<script setup lang="ts">
import { onUnmounted, onMounted, ref } from 'vue'
import { me, onLoginStateChange } from '../../user'
import api from '../../_api'
import Nav from '../components/Nav.vue'
import type { UserGroupRow } from '@common/Types'

const groups = ref<UserGroupRow[]>([])

const onInit = async () => {
  groups.value = me.value ? await api.admin.getGroups() : []
}

let offLoginStateChange: () => void = () => {}
onMounted(async () => {
  await onInit()
  offLoginStateChange = onLoginStateChange(onInit)
})

onUnmounted(() => {
  offLoginStateChange()
})
</script>
